import { render, staticRenderFns } from "./RmsDamdangFormModal.vue?vue&type=template&id=b4e38fe4&"
import script from "./RmsDamdangFormModal.vue?vue&type=script&lang=js&"
export * from "./RmsDamdangFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports